import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { hideMenu, showMenu } from '../../store/actions';
import TopNavBar from '../../components/TopNavBar/TopNavBar';
import Footer from '../../components/Footer/Footer';
import withGlobals from '../../withGlobals';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutFormV2';

import './UpdatePaymentMethodV2.css';

import { Elements } from '@stripe/react-stripe-js';

function UpdatePaymentMethodV2(props) {
  const [success, setSuccess] = useState(false);
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  );

  const { isMenuOpen, hideMenu, showMenu, location } = props;
  const policyId = location.query.policy_id;
  const paymentMethodId = location.query.payment_method_id;
  useEffect(() => {
    document.title = 'Update Payment Method - Sure';
  }, []);
  const handleSuccess = () => {
    setSuccess(true);
  };

  return (
    <div className="UpdatePaymentMethod">
      <TopNavBar
        isMenuOpen={isMenuOpen}
        onHideMenu={hideMenu}
        onShowMenu={showMenu}
      />
      <div className="UpdatePaymentMethod-content Container">
        {success ? (
          <h2>Your payment details have been updated.</h2>
        ) : (
          <>
            <Elements stripe={stripePromise}>
              <ElementsConsumer>
                {({ elements, stripe }) => (
                  <CheckoutForm
                    location={location}
                    elements={elements}
                    onSuccess={handleSuccess}
                    paymentMethodId={paymentMethodId}
                    policyId={policyId}
                    stripe={stripe}
                  />
                )}
              </ElementsConsumer>
            </Elements>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

const mapStateToProps = state => {
  return {
    isMenuOpen: state.isMenuOpen,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showMenu: () => dispatch(showMenu()),
    hideMenu: () => dispatch(hideMenu()),
  };
};

const enhance = compose(
  withRouter,
  withGlobals(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(UpdatePaymentMethodV2);
